export const PUBLISHED_STATUS_VALUES = [
  'CURRENT',
  'NOT_CURRENT',
  'ARCHIVED',
] as const;

export type PublishedStatus = typeof PUBLISHED_STATUS_VALUES[number];